/** @format */

const template = `
<div id="printable-application" class="student-application prior-learning-application row">
  <div class="offset-md-1 col-md-10 offset-xl-2 col-xl-8">
    <div class="row hidden-print">
      <div class="col-12">
        <div class="float-end">
          <button type="button" class="btn btn-primary btn-naked btn-sm" ng-click="$ctrl.goBack()">
            <sis-icon icon="back"></sis-icon>
            <span translate>STUDENT_APPLICATIONS.BACK</span>
          </button>
          <button type="button" class="btn btn-primary btn-sm print" ng-click="$ctrl.print()">
            <span translate>STUDENT_APPLICATIONS.PRINT</span>
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <h1 id="skip-link-target" tabindex="-1">
          {{'STUDENT_APPLICATIONS.TYPE.' + $ctrl.application.type | translate}}<!--
                --><span ng-if="$ctrl.application.name">: {{$ctrl.application.name}}</span
          ><!--
                --><span ng-if="$ctrl.application.courseUnit">: {{$ctrl.application.courseUnit.name | localizedString}}</span>
          <span class="tiny-badge" ng-class="$ctrl.getStatusBadgeColor()" ng-if="$ctrl.application">
            {{'STUDENT_APPLICATIONS.STATE.' + $ctrl.application.state | translate}}
          </span>
        </h1>
        <span class="guidance">{{'STUDENT_APPLICATIONS.code' | translate}}: {{$ctrl.application.code}}</span>
      </div>
    </div>
    <div class="application-container">
      <div ng-if="$ctrl.inclusionApplicationInstruction" class="guidance inclusion-application-instructions">
        <sis-localized-markup-string-view [content]="$ctrl.inclusionApplicationInstruction"> </sis-localized-markup-string-view>
      </div>

      <div class="application-information">
        <h2 translate>STUDENT_APPLICATIONS.APPLICATION_INFO</h2>

        <prior-learning-application-summary application="$ctrl.application" ng-if="$ctrl.isPriorLearningApplication()">
        </prior-learning-application-summary>
        <sis-prior-learning-list
          ng-if="$ctrl.isPriorLearningApplication()"
          [application-type]="$ctrl.application.type"
          [prior-learnings]="$ctrl.application.priorLearnings">
        </sis-prior-learning-list>

        <custom-attainment-application-summary application="$ctrl.application" ng-if="$ctrl.isCustomAttainmentApplication()">
        </custom-attainment-application-summary>

        <h3 translate>STUDENT_APPLICATIONS.DECISION</h3>
        <span class="decision-description" translate>
          {{'STUDENT_APPLICATIONS.' + ($ctrl.application.mustPrintDecision ? 'DECISION_REQUESTED_BY_MAIL' :
          'DECISION_NOT_REQUESTED_BY_MAIL')}}
        </span>
      </div>
      <div ng-if="$ctrl.hasDecision" class="decision-information">
        <h2 translate>STUDENT_APPLICATIONS.DECISION_INFO</h2>
        <attainment-application-decision-summary application="$ctrl.application"> </attainment-application-decision-summary>
      </div>
    </div>
  </div>
</div>
`;
export default template;
